﻿import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthGuardService } from '../_services/auth/auth.guard.service';

import { SecureComponent } from './secure.component';
import { HomeComponent } from './home/home.component';
import { DashboardComponent } from './home/dashboard/dashboard.component';
import { ContactsComponent } from './home/contacts/contacts.component';
import { ProductMainComponent } from './home/product-main/product-main.component';
import { CategoryComponent } from './home/product-main/category/category.component';
import { ProductsComponent } from './home/product-main/products/products.component';
import { EnquiryComponent } from './home/enquiry/enquiry.component';
import { ChangePasswordComponent } from './home/change-password/change-password.component';
import { ProductcateditComponent } from './home/product-main/productcatedit/productcatedit.component';
import { AddProductComponent } from './home/product-main/add-product/add-product.component';
import { AddCategoryComponent } from './home/product-main/category/add-category/add-category.component';
import { EditproductComponent } from './home/product-main/editproduct/editproduct.component';
import { SubscribersComponent } from './home/subscribers/subscribers.component';
import { ProductImagesComponent } from './home/product-main/product-images/product-images.component';

export const secureRoutes: Routes = [
    {
        path: 'secure', component: SecureComponent, canActivate: [AuthGuardService],
        children: [
            { path: '', redirectTo: 'home', pathMatch: 'full', canActivateChild: [AuthGuardService] },
            {
                path: 'home', component: HomeComponent, canActivateChild: [AuthGuardService],
                children: [
                    { path: '', component: DashboardComponent },
                    { path: 'dashboard', component: DashboardComponent },
                    { path: 'contacts', component: ContactsComponent },
                    { path: 'enquiry', component: EnquiryComponent },
                    { path: 'change-password', component: ChangePasswordComponent },
                    { path: 'subscribers', component: SubscribersComponent },
                    {
                        path: 'product', component: ProductMainComponent,
                        children: [
                            { path: '', redirectTo: 'products', pathMatch: 'full', canActivateChild: [AuthGuardService] },
                            { path: 'products', component: ProductsComponent },
                            { path: 'add-product', component: AddProductComponent },
                            { path: 'edit-product/:id', component: EditproductComponent },
                            { path: 'product-images/:id', component: ProductImagesComponent },
                            { path: 'category', component: CategoryComponent },
                            { path: 'add-category', component: AddCategoryComponent },
                            { path: 'edit-category/:id', component: ProductcateditComponent }
                        ]
                    }
                ]
            }
        ]
    }
];

@NgModule({
    imports: [
        RouterModule.forChild(secureRoutes)
    ],
    exports: [
        RouterModule
    ]
})

export class SecureRoutingModule { }
